const ETA_TRANSLATION_KEYS = Object.freeze({
  ETA_FOUR_MONTHS: "fourMonths",
  ETA_THREE_MONTHS: "threeMonths",
  ETA_TWO_MONTHS: "twoMonths",
  ETA_THREE_FOUR_WEEKS: "threeToFourWeeks",
  ETA_TWO_WEEKS: "twoToThreeWeeks",
  ETA_NEXT_WEEK: "twoWeeks",
  ETA_THIS_WEEK: "oneWeek",
  ETA_NEXT_DAY: "oneToTwoDays",
});

export const formatPurchaseRequestEta = (eta, t) => {
  if (eta === null || eta === undefined) {
    return t("CustomerOrders.purchaseRequestEta.atDealership");
  }

  if (typeof eta !== "string" || !Object.hasOwn(ETA_TRANSLATION_KEYS, eta)) {
    return undefined;
  }

  return t(`CustomerOrders.purchaseRequestEta.${ETA_TRANSLATION_KEYS[eta]}`);
};
